// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1i69x","controls":"styles_controls__1asdm","charLimit":"styles_charLimit__PrxiQ","input":"styles_input__HNnsX","send":"styles_send__gGVj0"};